import { useEffect, useState } from 'react';

const passwordContainsUpperAndLowerRegex = /^(?=.*[a-z])(?=.*[A-Z]).*$/;
export const passwordContainsUpperAndLowerTest = (password: string) =>
  passwordContainsUpperAndLowerRegex.test(password);

const passwordContainsNumberRegex = /^(?=.*\d).*$/;
export const passwordContainsNumberTest = (password: string) =>
  passwordContainsNumberRegex.test(password);

const passwordLengthRegex = /^\S{8,64}$/;
export const passwordLengthTest = (password: string) =>
  passwordLengthRegex.test(password);

export interface PasswordStrength {
  lengthTest: boolean;
  upperAndLowercaseTest: boolean;
  numberTest: boolean;
  strong: boolean;
}

const usePasswordStrengthCheck = (
  currentPassword?: string
): PasswordStrength => {
  const [passwordStrength, setPasswordStrength] = useState<PasswordStrength>({
    lengthTest: false,
    upperAndLowercaseTest: false,
    numberTest: false,
    strong: false,
  });

  useEffect(() => {
    if (currentPassword) {
      const currentResults = { ...passwordStrength };

      currentResults.lengthTest = passwordLengthTest(currentPassword);
      currentResults.upperAndLowercaseTest =
        passwordContainsUpperAndLowerTest(currentPassword);
      currentResults.numberTest = passwordContainsNumberTest(currentPassword);

      if (
        currentResults.lengthTest &&
        currentResults.upperAndLowercaseTest &&
        currentResults.numberTest
      ) {
        currentResults.strong = true;
      } else {
        currentResults.strong = false;
      }
      setPasswordStrength(currentResults);
    }
  }, [currentPassword]);

  return passwordStrength;
};

export default usePasswordStrengthCheck;
